var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDessertCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.905605,
    y: 0.905605,
    width: 43.469,
    height: 43.469,
    rx: 21.7345,
    stroke: "#FCC436",
    strokeWidth: 1.81121
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.212 18.0158V30.641C35.212 31.0912 34.8473 31.4555 34.3975 31.4555H10.7762C10.3264 31.4555 9.96167 31.0912 9.96167 30.641V18.0158C9.96167 17.5664 10.3264 17.2013 10.7762 17.2013L24.6216 14.9864",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5542 13.9641C33.6084 14.1719 35.212 15.9071 35.212 18.0158",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96168 17.6593L10.3689 22.903C11.4937 22.903 12.4053 21.9914 12.4053 20.8671C12.4053 19.7423 13.3168 18.8304 14.4416 18.8304C15.5663 18.8304 16.4779 19.7423 16.4779 20.8671C16.4779 21.9914 17.3895 22.903 18.5142 22.903C19.6389 22.903 20.5505 21.9914 20.5505 20.8671C20.5505 19.7423 21.4621 18.8304 22.5868 18.8304C23.7116 18.8304 24.6232 19.7423 24.6232 20.8671C24.6232 21.9914 25.5347 22.903 26.6595 22.903C27.7842 22.903 28.6958 21.9914 28.6958 20.8671C28.6958 19.7423 29.6074 18.8304 30.7321 18.8304C31.8568 18.8304 32.7684 19.7423 32.7684 20.8671C32.7684 21.9914 33.68 22.903 34.8047 22.903L34.413 14.4897",
    fill: "#FCC436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96167 26.8845H35.212",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0849 17.3381C29.9598 17.3381 31.4796 15.8183 31.4796 13.9434C31.4796 12.0686 29.9598 10.5487 28.0849 10.5487C26.21 10.5487 24.6902 12.0686 24.6902 13.9434C24.6902 15.8183 26.21 17.3381 28.0849 17.3381Z",
    fill: "white",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0848 13.1287C28.0848 10.8794 29.908 9.05605 32.1575 9.05605",
    stroke: "#FCC436",
    strokeWidth: 1.81121,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDessertCat);
export default __webpack_public_path__ + "static/media/dessertCat.8ae32f1f108c3e35a17e29aba76b4120.svg";
export { ForwardRef as ReactComponent };